const ServiceTypesReducer = (state = {}, actions)=>{
    switch(actions.type){

        case 'ServiceTypes':
            return{...state, service_type:actions.payload}

        case 'GetServiceTypes_Desc':
            return{...state, desc:actions.desc, asc:actions.asc, order:actions.order, th:actions.th}

        case 'GetServiceTypes_Asc':
            return{...state, desc:actions.desc, asc:actions.asc, order:actions.order, th:actions.th}

        case 'qtd_per_page_service_types':
            return{...state, qtd_per_page:actions.payload}

        case 'pesquisaServiceTypes':
            return{...state, pesquisa:actions.payload}

        case 'clearPesquisaServiceTypes':
            return{...state, pesquisa:actions.payload}

        case 'changePageServiceTypes':
            return{...state, page:actions.payload}

        default:
            return state;
    }
}
export default ServiceTypesReducer;